import { useQuasar } from 'quasar'

export function usePlatform() {
  const $q = useQuasar()

  return {
    isMobile: $q.platform.is.mobile,
    isCordova: $q.platform.is.cordova,
  }
}
